export function formatTextWithNewLines(inputText) {
    if (inputText)
        return inputText.replace(/\n/g, '<br>');
}

export function highlightTextWord(text) {
    if (text) {
        return text.replace(/\[([^\]]+)\]/g, '<span>$1 <img class="wow bounceIn" data-wow-duration="1.5s" data-wow-delay=".4s" src="/assets/lms_website/website-assets/img/unlerline/hero-2-svg-1.svg" alt=""/></span>');
    }
}

export function highlightSectionTextWord(text) {
    if (text) {
        return text.replace(/\[([^\]]+)\]/g, '<span>$1 <img class="tp-underline-shape-5 wow bounceIn" data-wow-duration="1.5s" data-wow-delay=".4s" src="/assets/lms_website/website-assets/img/shape/bottom-line/line-2-category.svg" alt=""/></span>');
    }
}

export function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export function getCookie(cname, default_val = '') {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return default_val;
}


export function loadScriptOnceWithPromise(srcUrl) {
    return new Promise((resolve, reject) => {
        // If already loaded, resolve immediately
        if (document.querySelector(`script[src="${srcUrl}"]`)) {
            resolve();
            return;
        }

        const script = document.createElement('script');
        script.src = srcUrl;
        script.type = 'text/javascript';
        script.async = true;

        script.onload = () => resolve();
        script.onerror = () => reject(new Error(`Failed to load script: ${srcUrl}`));

        document.head.appendChild(script);
    });
}
